<template>
    <v-expansion-panel
        v-model="value"
        expand
    >
        <v-expansion-panel-content
            v-for="(item_list,index) in list"
            :key="index"
            expand-icon=""
        >
            <v-layout slot="header">
                <v-flex>{{ item_list.title }}</v-flex>
                <roundButton :icon_name="value[index] ? 'minus' : 'plus'" :class="{'btn--icon-white': value[index]}" class="mr-2" />
            </v-layout>
            <v-card v-for="(content,idx) in item_list.content" :key="idx">
                <component :content="content.content" :is="content.type" />
            </v-card>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>
import listCards   from '@/components/view_blocks/Database/list_blocks/list_cards';
import listTabs   from '@/components/view_blocks/Database/list_blocks/list_tabs';
import listText   from '@/components/view_blocks/Database/list_blocks/list_text';
import roundButton   from '@/components/ui/buttons/buttons_icon/round_button';
import {mapGetters, mapActions} from 'vuex';
export default {
  components: {
    listCards,
    listTabs,
    listText,
    roundButton,
  },
  data() {
    return {
      pagination: {
        sortBy: 'name',
      },
      value: [],
    };
  },
  computed: {
    ...mapGetters('database/oem', [
      'list',
    ]),
  },
  mounted() {
    this.get_oem();
  },
  methods: {
    ...mapActions('database/oem', [
      'get_oem',
    ]),
  },
};
</script>
